import Small07 from './07.png';
import Small08 from './08.png';
import Small09 from './09.png';
import Small10 from './10.png';
import Small11 from './11.png';
import Small12 from './12.png';
import Small13 from './13.png';
import Small14 from './14.png';
import Small20 from './20.png';
import Small21 from './21.png';
import Small22 from './22.png';
import Small23 from './23.png';
import Small24 from './24.png';
import SmallBook from './book.jpg';
import SmallDOC from './doc.png';
import SmallFile from './file.png';
import SmallFolder from './folder.png';
import SmallJPG from './jpg.png';
import SmallLink from './link.png';
import SmallPDF from './pdf.png';
import SmallPNG from './png.png';
import SmallPPT from './ppt.png';
import SmallVideo from './video.png';
import SmallXLS from './xls.png';

export {
  Small07,
  Small08,
  Small09,
  Small10,
  Small11,
  Small12,
  Small13,
  Small14,
  SmallBook,
  SmallFolder,
  SmallFile,
  Small20,
  Small21,
  Small22,
  Small23,
  Small24,
  SmallPDF,
  SmallPNG,
  SmallJPG,
  SmallPPT,
  SmallDOC,
  SmallLink,
  SmallVideo,
  SmallXLS,
};
